import { render, staticRenderFns } from "./agree-common.vue?vue&type=template&id=002329c5&scoped=true&"
import script from "./agree-common.vue?vue&type=script&lang=ts&"
export * from "./agree-common.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002329c5",
  null
  
)

export default component.exports